'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var PropTypes = require('prop-types');
var constants_legacy_theme = require('../../constants/legacy/theme.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var Body = styled__default["default"].span.withConfig({
  displayName: "Body",
  componentId: "sc-xcreqg-0"
})(["font-family:", ";font-size:", ";line-height:1.2;font-weight:", ";color:", ";margin:0;"], constants_legacy_theme.FONTS.PRIMARY, constants_legacy_theme.FONT_SIZES.DEFAULT, function (props) {
  return props.bold ? 600 : 'normal';
}, constants_legacy_theme.COLORS.BLACK_50);
Body.propTypes = {
  bold: PropTypes__default["default"].bool
};

exports["default"] = Body;
